class MegaMenuDrawerHighlight extends HTMLElement {
  connectedCallback() {
    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  // Drawer keeps ancestor pages visible (slides via transforms), so track the
  // root drill-link click rather than page visibility.
  onClick(event) {
    const link = event.target.closest('drawer-menu-page-link[data-page-id]');
    if (!link) return;

    const rootPage = link.closest("drawer-menu-page[data-page-id='Menu']");
    if (!rootPage) return;

    const id = link.getAttribute('data-page-id');
    if (!id || !id.startsWith('DrawerMenuPage-')) return;

    this.querySelectorAll('.is-last-visited').forEach((node) =>
      node.classList.remove('is-last-visited')
    );
    link.classList.add('is-last-visited');
  }
}

customElements.define('mega-menu-drawer-highlight', MegaMenuDrawerHighlight);
